<!--
/*
 * @Description: login组件容器
 * @Author: Guojun
 * @Date: 2020-05-19 14:43:48
 * @LastEditTime: 2020-5-20 09:02:47
 */
  -->
<template>
<div class="model_bg" v-if="show">
    <div class="wrap" v-if="type=='noywy'">
       <h3>提示</h3>
       <div class="into">您还未绑定快递员,或快递员已解绑，无法正常使用下单功能，请点击“去绑定”按钮绑定快递员。</div>
       <div class="btnBox"><el-button type="primary" @click="show=false" style="margin-top:50px">我知道了</el-button></div>     
    </div>
    <div class="wrap" v-if="type=='voidance'">
       <h3>快递员已和您解除绑定关系，无法正常打印，请联系协议快递员重新申请绑定</h3>
       <h3>如何申请绑定:</h3>
       <div class="into">1.快递员打开“韵镖侠“App，点击底部【客户】按键，进入“我的客户页面”，点击右上角【协议客户二维码】；</div>
       <div class="into">2.商家客户扫描二维码，提交申请资料进行申请绑定</div>
       <div class="btnBox"><el-button type="primary" @click="show=false" style="margin-top:50px">我知道了</el-button></div>     
    </div>
    <div class="uploadBox" v-else-if="type=='upFinsh'">
       <h3>您上传的联系人信息已解析完毕</h3>
       <h3>请前往地址管理页面刷新页面查看</h3>
       <div class="into">上传总量为<u>{{contentData.total}}</u>条,其中失败<b style="color:red">{{contentData.exceptCount}}</b>条</div>
       <div class="into" v-if="contentData.exceptCount > 0">上传失败联系人请<a :href="contentData.fileurl" style="color:#409EFF;text-decoration:underline">点击下载</a>,检查修改后重新上传！</div>
       <div class="btnBox"><el-button type="primary" @click="loadPage" style="margin-top:50px">我知道了</el-button></div>     
    </div>
    <div class='ywybillwarn' v-else-if="type=='ywyauthorize'">
       <h4>{{contentData.title}}</h4>
       <div class="content" v-html="contentData.htmlstring"></div>
       <div class="bottom" @click="warnKonw">我知道了</div> 
    </div>
    <div class="newtipInfo" v-else-if="type=='newtipInfo'">
      <header>系统消息 <i class="el-icon-close" @click="InfoClose"></i></header>
      <div class="content">
         <div style="padding-bottom:20px;text-align:center;font-weight:bold">{{contentData.title}}</div>
         <div v-html="contentData.content"></div>
      </div>
      <div class="bottom" @click="gotodetail">查看详情</div> 
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      contentData:{},
      type:'',
      callback:null,
    };
  },
  created() {

  },
  mounted() {
  },
  methods: {
    gotodetail(){
      this.InfoClose();
      window.open(window.location.origin + '/question/ysbmailDetail?id='+this.contentData.id);
    },
    InfoClose(){
      this.show = false;
    },
    loadPage(){
      this.show = false;
      if(this.$store.state.addressMenu = '/addressMenu'){
        window.location.reload();
      }
    },
    warnKonw(){
      this.show = false;
      this.callback('confirm');
    }
  },
};
</script>
 
<style lang="stylus" scoped>
.model_bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
  font-size 14px;
}
.wrap {
  background-color: #ffffff;
  width: 320px;
  height: 200px;
  z-index: 99;
  line-height: 26px;
  text-align: left;
  padding: 20px 40px 0 40px;
  z-index: 99;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -320px;
  margin-top: -160px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  animation-name: wrapscale;
  animation-duration: 300ms;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-delay: 0s;
  @keyframes wrapscale {
    0% {
      top: 100%;
    }
    100% {
      top: 50%;
    }
  }
}
.uploadBox{
  background-color: #ffffff;
  width: 340px;
  height: 200px;
  z-index: 99;
  line-height: 26px;
  text-align: left;
  padding: 40px;
  line-height 30px;
  z-index: 99;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -211px;
  margin-top: -141px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  animation-name: wrapscale;
  animation-duration: 300ms;
  animation-iteration-count: 1;
  animation-timing-function: linear;
  animation-delay: 0s;
  @keyframes wrapscale {
    0% {
      top: 100%;
    }
    100% {
      top: 50%;
    }
  }
  u,b{
    padding: 0 6px;
  }
}
.into{
  color #666666;
}
.btnBox{
  text-align: center;
}
a{
  color:"#409EFF"
  text-decoration underline;
}
.ywybillwarn{
  position: absolute;
  background-color: #ffffff;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  border-radius: 8px;
  h4{
    line-height: 40px;
    height: 40px;
    text-align: center;
  }
  .content{
    padding:0 30px 10px 30px;
  }
  .bottom{
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409EFF;
    border-top:1px solid #DCDFE6;
    cursor: pointer;
  }
}
.newtipInfo{
  position: absolute;
  background-color: #ffffff;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  border-radius: 10px;
  width: 600px;
  header{
    background-color: #409EFF;
    height: 40px;
    line-height: 40px;
    color: #fff;
    text-align: center;
    border-radius: 10px 10px 0 0;
    position relative;
    i{
      position absolute;
      right: 10px;
      top:10px;
      font-size:20px;
    }
  }
  .content{
    padding: 20px 50px;
  }
  .bottom{
    height: 32px;
    line-height: 32px;
    text-align: center;
    background:#409EFF;
    cursor: pointer;
    color: #fff
    width: 100px;
    margin: 0 auto 20px auto;
    border-radius: 8px;
  }
}
</style>